"use strict";

import debug from "../qa/debug.js";

const performance = (globalWindow, index) => {
    const module = {};

    const mark = (startName) => {
        try {
            globalWindow.performance.mark(startName);
        } catch (e) {
            debug.log("Performance api is probably not supported in this browser");
        }
    };

    const measure = (cinemaName) => {
        try {
            globalWindow.performance.measure(cinemaName, CINEMA_LOADING_START);
        } catch (e) {
            debug.log("Performance api is probably not supported in this browser");
        }
    };

    const getEntriesByName = (cinemaName) => {
        try {
            return globalWindow.performance.getEntriesByName(cinemaName);
        } catch (e) {
            debug.log("Performance api is probably not supported in this browser");
        }
    };

    const CINEMA_LOADING_START = "reco_cinemaLoadingStart_" + index;

    module.cinemaLoadingStarted = () => {
        mark(CINEMA_LOADING_START);
    };

    module.cinemaLoaded = (cinemaName) => {
        try {
            measure(cinemaName);
            const entriesByName = getEntriesByName(cinemaName);
            if (entriesByName) {
                debug.log(cinemaName + " took " + entriesByName[0].duration + "ms to load");
            }
        } catch (err) {
            debug.log("ignoring error while measuring performance", err);
        }
    };

    return module;
};

export default performance;
